import axios from 'axios'
import _get from 'lodash/get'

import { ERROR_MESSAGE_SAVING } from '@/constants'

import { handleRequestError } from './request'

export const RECEIVE_SELF_EMPLOYMENT = 'RECEIVE_SELF_EMPLOYMENT'
export const REQUEST_SELF_EMPLOYMENT = 'REQUEST_SELF_EMPLOYMENT'
export const RESOLVE_SELF_EMPLOYMENT_NAVIGATION = 'RESOLVE_SELF_EMPLOYMENT_NAVIGATION'
export const SAVE_SELF_EMPLOYMENT = 'SAVE_SELF_EMPLOYMENT'
export const UPDATE_AND_SAVE_SELF_EMPLOYMENT = 'UPDATE_AND_SAVE_SELF_EMPLOYMENT'

export const requestSelfEmployment = (selfAssessmentId) => (dispatch) => {
    dispatch({ type: REQUEST_SELF_EMPLOYMENT, data: { selfAssessmentId } })

    axios
        .get(`/selfemployment/${selfAssessmentId}`)
        .then((response) => {
            const data = _get(response, ['data'], {})
            dispatch(receiveSelfEmployment({ ...data, fetchSuccessful: true }))
        })
        .catch((error) => {
            if (_get(error, ['response', 'status']) === 404) {
                dispatch(receiveSelfEmployment({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveSelfEmployment({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveSelfEmployment = (data) => ({ type: RECEIVE_SELF_EMPLOYMENT, data })

export const updateAndSaveSelfEmployment = (data) => (dispatch) => {
    dispatch({ type: UPDATE_AND_SAVE_SELF_EMPLOYMENT, data })

    dispatch(receiveSelfEmployment(data))
    return dispatch(saveSelfEmployment())
}

export const saveSelfEmployment = () => (dispatch, getState) => {
    dispatch({ type: SAVE_SELF_EMPLOYMENT })

    const { assessment, selfEmployment } = getState()

    const { id: selfAssessmentId } = assessment
    const { isAllowanceUpdate, shouldGoToNextAllowanceQuestion } = selfEmployment

    return axios
        .put(`/selfemployment/${selfAssessmentId}`, {
            ...selfEmployment,
            selfAssessmentId,
        })
        .then((response) => {
            dispatch(receiveSelfEmployment(response.data))

            dispatch(
                resolveSelfEmploymentNavigation({
                    isAllowanceUpdate,
                    shouldGoToNextAllowanceQuestion,
                })
            )
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const resolveSelfEmploymentNavigation = (data) => ({ type: RESOLVE_SELF_EMPLOYMENT_NAVIGATION, data })
